import { NonEmptyArray, ERoomType } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectRoomTypeFilter } from 'shared/selectors/advancedFilters';

export const RoomTypeContainer: FC = () => {
  const { value, options } = useSelector(selectRoomTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (roomType: NonEmptyArray<ERoomType> | null) => {
      onChange({ action: 'setRoomTypes', arguments: [roomType] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label="Комнатность">
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleChange} />
    </AdvancedFilterRow>
  );
};
